import { hmsToSecondsOnly } from '../../shared/utils';
import { MILLIS_PER_SECOND } from '../../helpers/assets/durationSecondsToMillis';

export default function resolveDuration(assetDuration, rawDuration) {
  if (Number.isFinite(assetDuration)) return assetDuration;
  if (Number.isFinite(rawDuration)) return secondsToMillis(rawDuration);
  if (typeof rawDuration !== 'string' || !rawDuration) return null;

  const normalizedValue = rawDuration.trim().replace(/\s*s$/i, '');
  if (/^\d+(?:\.\d+)?$/.test(normalizedValue)) {
    return secondsToMillis(Number(normalizedValue));
  }

  return secondsToMillis(hmsToSecondsOnly(rawDuration));
}

function secondsToMillis(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return null;
  return Math.round(seconds * MILLIS_PER_SECOND);
}
